// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { Button } from 'antd';
import React, { ReactElement, ReactNode } from 'react';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';

import './HeaderButton.scss';

interface HeaderButtonProps {
    icon: ReactNode;
    label: string;
    disabled?: boolean;
    className?: string;
    onClick?: () => void;
}
/* eslint-disable */
const HeaderButton = React.forwardRef(
    ({ icon, label, className = '', disabled, onClick, ...restProps }: HeaderButtonProps, ref): ReactElement => {
        return (
            <span className={classList('button-header', className)} onClick={disabled ? undefined : onClick}>
                <THTooltip title={label} placement="bottom">
                    <Button className="button-header" shape="circle" icon={icon} disabled={disabled} {...restProps} />
                </THTooltip>
            </span>
        );
    },
);
/* eslint-enable */
export default HeaderButton;
